// tslint:disable:max-line-length

import React from 'react';

export const OperatorLessThan = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.71,11.87,4.29,8.62V7.38l7.42-3.25V6l-5,2,5,2Z" />
    </svg>
  );
};
